<!-- Annotation Target Form -->
@if (annotationTargetForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationTargetForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.target">
      </h4>
      <!-- Text Color -->
      <medsurf-design-form-control-input-color-picker [control]="annotationTargetForm.controls.color"
        [class]="'w-full'"
        [label]="'global.color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <!-- Tip Type -->
      <medsurf-design-form-control-input-dropdown [control]="annotationTargetForm.controls.endType"
        [class]="'w-full'"
        [options]="FlatModels.AnnotationEntityModels.TipTypeArray"
        [label]="'global.end'"
      (valueChange)="onEndTypeChange()"></medsurf-design-form-control-input-dropdown>
      <!-- End Radius -->
      <medsurf-design-form-control-input-slider [hidden]="annotationTargetForm.value.endType !== FlatModels.AnnotationEntityModels.TipType.enum.circle"
        [control]="annotationTargetForm.controls.endRadius"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
        [label]="'global.circle_radius'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}